import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Confirmation de suppression d'un document stocké (achat / technique).
 */
@Component({
  selector: 'app-document-delete-dialog',
  templateUrl: './document-delete-dialog.component.html',
  styleUrls: ['./document-delete-dialog.component.css'],
  imports: [TranslateModule],
})
export class DocumentDeleteDialogComponent {
  /** Préfixe i18n : `documentsAchat` ou `dossierTechnique`. */
  @Input({ required: true }) i18nPrefix!: string;

  @Input() typeLabel = '';
  @Input() fileName = '';
  @Input() deleting = false;
  @Input() errorMessage: string | null = null;
  /** Affiche le contenu du dialog (ligne sélectionnée). */
  @Input() active = false;

  @Output() readonly cancelRequest = new EventEmitter<void>();
  @Output() readonly confirmRequest = new EventEmitter<void>();
  @Output() readonly dialogCancel = new EventEmitter<Event>();

  @ViewChild('dialog')
  private readonly dialogRef?: ElementRef<HTMLDialogElement>;

  show(): void {
    this.dialogRef?.nativeElement.showModal();
  }

  close(): void {
    this.dialogRef?.nativeElement.close();
  }

  key(suffix: string): string {
    return `${this.i18nPrefix}.${suffix}`;
  }

  typeKey(): string {
    return `${this.i18nPrefix}.types.${this.typeLabel}`;
  }
}
